export default __webpack_public_path__ + "23b8cbd859a139b2d705c948a46fe4a6.gif";